import { isValidPhoneNumber, PhoneNumber } from '@nemuru-eng/js-api-client';

export const validatePhoneNumber = (phoneNumber: string | null) => {
  if (!phoneNumber) return true;
  try {
    const formattedPhoneNumber = new PhoneNumber(phoneNumber);
    return isValidPhoneNumber(formattedPhoneNumber.value);
  } catch (error) {
    return false;
  }
};
